import { render } from "./Charts0border.vue?vue&type=template&id=55c3c03c&scoped=true"
import script from "./Charts0border.vue?vue&type=script&lang=js"
export * from "./Charts0border.vue?vue&type=script&lang=js"

import "./Charts0border.vue?vue&type=style&index=0&id=55c3c03c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c3c03c"]])

export default __exports__